import { useControl } from 'react-map-gl';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { LayerToggle } from './LayerToggle';

/** 
 * We need to wrap the LayerToggle inside the useControl or else 
  - maplibre will not add it to the default map control (current location, scale etc)
 * this makes sure that the elements are properly accessible in order, which is the only reason why we are doing this 
 **/

const LayerToggleControl = () => {
  const controlDiv = useRef(document.createElement('div'));

  useControl(() => ({
    onAdd: () => {
      controlDiv.current.className = 'maplibregl-ctrl maplibregl-ctrl-group';
      return controlDiv.current;
    },
    onRemove: () => {
      if (controlDiv.current.parentNode) {
        controlDiv.current.parentNode.removeChild(controlDiv.current);
      }
    },
  }), { position: 'bottom-right' });

  //MapLibre manages it's own DOM hence createPortal
  return ReactDOM.createPortal(
    <div style={{ all: 'initial' }}>
      <LayerToggle />
    </div>,
    controlDiv.current
  );
};

export default LayerToggleControl;

